import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BlameDeactivationReasons } from '@vendasta/accounts/legacy';

export interface DeactivateImmediatelyDialogDataInterface {
  itemName: string;
  commitmentDate: string;
}

@Component({
  styleUrls: ['deactivate-immediately-dialog.component.scss'],
  template: `
    <form (ngSubmit)="deactivateAddon()">
      <h2 mat-dialog-title>{{ titleText }}</h2>
      <mat-dialog-content class="dialog-content">
        <div class="warning-banner">
          <mat-icon class="warning-banner__icon">info_outline</mat-icon>
          {{ commitmentText }}
        </div>
        <div class="explanation">{{ explanationText }}</div>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button type="button" mat-button color="primary" matDialogClose>no, keep</button>
        <button mat-raised-button color="warn">deactivate now</button>
      </mat-dialog-actions>
    </form>
  `,
})
export class DeactivateImmediatelyDialogComponent implements OnInit {
  titleText: string;
  explanationText: string;
  commitmentText: string;

  deactivationInfo: EventEmitter<BlameDeactivationReasons> = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<DeactivateImmediatelyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeactivateImmediatelyDialogDataInterface,
  ) {
    this.titleText = `Deactivate ${data.itemName}`;
    this.commitmentText = `${data.itemName} will continue to be billed until the end of the commitment on ${data.commitmentDate}`;
    this.explanationText = `This will remove the add-on from this account and end all syndication services.`;
  }

  ngOnInit(): void {
    return;
  }

  deactivateAddon(): void {
    const deactivationInfo = new BlameDeactivationReasons();
    this.deactivationInfo.emit(deactivationInfo);
    this.dialogRef.close();
  }
}
